import { render, staticRenderFns } from "./BindAccountModal.vue?vue&type=template&id=1df8f9bc&scoped=true"
import script from "./BindAccountModal.vue?vue&type=script&lang=js"
export * from "./BindAccountModal.vue?vue&type=script&lang=js"
import style0 from "./BindAccountModal.vue?vue&type=style&index=0&id=1df8f9bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df8f9bc",
  null
  
)

export default component.exports